import { Group, Material } from 'three';

export interface MaterialInfo {
    index: number;
    name: string;
    mtllib: string;
    smooth: boolean;
    groupStart: number;
    groupEnd: number;
    groupCount: number;
    inherited: boolean;
    clone(index?: number): MaterialInfo;
}

export interface GeometryData {
    vertices: number[];
    normals: number[];
    colors: number[];
    uvs: number[];
    hasUVIndices: boolean;
    type?: string;
}

export interface ObjectData {
    name: string;
    fromDeclaration: boolean;
    geometry: GeometryData;
    materials: MaterialInfo[];
    smooth: boolean;
    startMaterial(name: string, libraries: string[]): MaterialInfo;
    currentMaterial(): MaterialInfo | undefined;
    _finalize(end: boolean): MaterialInfo | undefined;
}

export interface MaterialCreator {
    create(name: string): Material | undefined;
}

export class LoaderGroup extends Group {
    materialLibraries: string[] = [];
}
